import React, { useState } from 'react';
import Button from '../components/ui/Button';
import { login, signInWithGoogle } from '../services/authentication';
import gabmicLogo from '../assets/gabmic-logo.png';

const SignInPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const pageStyle: React.CSSProperties = {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem',
  };

  const formContainerStyle: React.CSSProperties = {
    width: '100%',
    maxWidth: '400px',
    padding: '3rem 2rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
  };

  const inputStyle: React.CSSProperties = {
    padding: '0.75rem 1rem',
    backgroundColor: 'var(--bg-background)',
    border: '1px solid var(--border-color)',
    borderRadius: '4px',
    color: 'var(--text-main)',
    fontSize: '1rem',
    outline: 'none',
  };

  const handleEmailSignIn = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      await login(email, password);
      window.location.assign('/dashboard');
    } catch (err: any) {
      setError(err.message || 'Invalid email or password. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoogleAuth = async () => {
    setError('');
    try {
      await signInWithGoogle();
      window.location.assign('/dashboard');
    } catch (err: any) {
      setError(err.message || 'Google sign in failed.');
    }
  };

  return (
    <div style={pageStyle}>
      <div className="matte-surface" style={formContainerStyle}>
        <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
          <a href="/">
            <img src={gabmicLogo} alt="GabMic" style={{ height: '34px', margin: '0 auto 2rem auto' }} />
          </a>
          <h1 style={{ fontSize: '1.75rem', marginBottom: '0.5rem' }}>Welcome Back</h1>
          <p style={{ margin: 0, fontSize: '0.875rem', color: 'var(--text-secondary)' }}>Sign in to analyze your business data</p>
        </div>

        {error && (
          <div style={{ padding: '0.75rem', backgroundColor: 'rgba(239, 68, 68, 0.1)', border: '1px solid var(--status-danger)', borderRadius: '4px', color: 'var(--status-danger)', fontSize: '0.875rem', textAlign: 'center' }}>
            {error}
          </div>
        )}

        <form onSubmit={handleEmailSignIn} style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            <label className="mono-label" style={{ margin: 0 }}>Work Email</label>
            <input style={inputStyle} type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            <label className="mono-label" style={{ margin: 0 }}>Password</label>
            <input style={inputStyle} type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </div>

          <Button type="submit" variant="primary" fullWidth disabled={isLoading}>
            {isLoading ? 'Signing in...' : 'Sign In'}
          </Button>
        </form>

        <div style={{ display: 'flex', alignItems: 'center', margin: '0.5rem 0' }}>
          <div style={{ flex: 1, height: '1px', backgroundColor: 'var(--border-color)' }}></div>
          <span style={{ padding: '0 1rem', color: 'var(--text-secondary)', fontSize: '0.75rem', fontFamily: 'var(--font-mono)' }}>OR</span>
          <div style={{ flex: 1, height: '1px', backgroundColor: 'var(--border-color)' }}></div>
        </div>

        <Button type="button" variant="secondary" fullWidth onClick={handleGoogleAuth}>
          Continue with Google
        </Button>

        <p style={{ textAlign: 'center', fontSize: '0.875rem', marginTop: '1rem', color: 'var(--text-secondary)' }}>
          Don't have an account? <a href="/signup" style={{ color: 'var(--gabmic-orange)' }}>Create one</a>
        </p>
      </div>
    </div>
  );
};

export default SignInPage;
